import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-row" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "app-info" }
const _hoisted_4 = { class: "name-row" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = { class: "action-row" }
const _hoisted_8 = { class: "iap" }


import { useI18n } from 'vue-i18n';
import type { RelatedApp } from '@/lib/app-data';
import { relatedAppNameKey, relatedAppSubtitleKey } from '../i18n-keys';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppRow',
  props: {
    app: {}
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.app.icon,
      alt: _unref(t)(_unref(relatedAppNameKey)(_ctx.app.i18nKey)),
      class: "app-icon"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.app.isAd)
          ? (_openBlock(), _createBlock(_component_van_tag, {
              key: 0,
              plain: "",
              type: "primary",
              color: "#6b7280",
              class: "ad-tag"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('appStore.ad')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)(_unref(relatedAppNameKey)(_ctx.app.i18nKey))), 1)
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)(_unref(relatedAppSubtitleKey)(_ctx.app.i18nKey))), 1),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.app.installed)
          ? (_openBlock(), _createBlock(_component_van_icon, {
              key: 0,
              name: "down",
              size: "20",
              color: "#007AFF"
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_van_button, {
                round: "",
                size: "mini",
                class: "get-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('appStore.action')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('appStore.inAppPurchases')), 1)
            ], 64))
      ])
    ])
  ]))
}
}

})